import React, {
	forwardRef,
	useImperativeHandle,
	useState,
	useEffect,
} from "react";
import css from "./TemplateReview.module.css";
import { DownloadFile } from "../../../../../Services/Server";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";

// Set the worker source for react-pdf
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const TemplateReview = forwardRef(({ init, clauseList }, ref) => {
	const clauses = clauseList ? clauseList.filter((c) => c.selected) : [];
	const [documentUrl, setDocumentUrl] = useState(null);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	const [numPages, setNumPages] = useState(null);

	const onDocumentLoadSuccess = ({ numPages }) => {
		setNumPages(numPages);
	};

	useEffect(() => {
		if (init && init.doc_id) {
			setLoading(true);
			setError(null);
			DownloadFile(init.doc_id)
				.then((resp) => {
					if (resp instanceof Blob) {
						const url = URL.createObjectURL(resp);
						setDocumentUrl(url);
						setError(null);
					} else {
						throw new TypeError(
							"Invalid file response from server. Expected a Blob."
						);
					}
				})
				.catch((err) => {
					console.error("Error downloading file for review:", err);
					setError("Failed to load document preview.");
				})
				.finally(() => {
					setLoading(false);
				});
		} else {
			if (documentUrl) {
				URL.revokeObjectURL(documentUrl);
			}
			setDocumentUrl(null);
			setError(null);
		}

		return () => {
			if (documentUrl) {
				URL.revokeObjectURL(documentUrl);
			}
		};
	}, [init.doc_id]);

	const pages = Array.from(new Array(numPages), (el, index) => index + 1);

	return (
		<div className={css.Review}>
			<p className={css.Title}>Contract Review</p>
			<div>
				<p className={css.SubTitle}>Service Provider's Information</p>
				<div>
					<div className={css.InfoRow}>
						<div className={css.Items}>
							<p className={css.Key}>Company: </p>
							<p>Fieldbase Services Limited</p>
						</div>
						<div className={css.Items}>
							<p className={css.Key}>Email: </p>
							<p>sales@fbase.co.uk</p>
						</div>
					</div>
					<div className={css.InfoRow}>
						<div className={css.Items}>
							<p className={css.Key}>Company Number: </p>
							<p>F10637893</p>
						</div>
						<div className={css.Items}>
							<p className={css.Key}>Phone: </p>
							<p>07425-155-321</p>
						</div>
					</div>
					<div className={css.InfoRow}>
						<div className={css.Items}>
							<p className={css.Key}>Vat Number: </p>
							<p>313 7483 09</p>
						</div>
						<div className={css.Items}>
							<p className={css.Key}>Country: </p>
							<p>United Kingdom</p>
						</div>
					</div>
					<div className={css.InfoRow}>
						<div className={css.Items}>
							<p className={css.Key}>Contact First Name: </p>
							<p>Chinedu</p>
						</div>
						<div className={css.Items}>
							<p className={css.Key}>Province: </p>
							<p>Greater London</p>
						</div>
					</div>
					<div className={css.InfoRow}>
						<div className={css.Items}>
							<p className={css.Key}>Contact Last Name: </p>
							<p>Abanobi</p>
						</div>
						<div className={css.Items}>
							<p className={css.Key}>City: </p>
							<p>London</p>
						</div>
					</div>
					<div className={css.InfoRow}>
						<div className={css.Items}>
							<p className={css.Key}>Role: </p>
							<p>Managing Director</p>
						</div>
						<div className={css.Items}>
							<p className={css.Key}>Postal Code: </p>
							<p>EC3V 3NG</p>
						</div>
					</div>
					<div className={css.InfoRow}>
						<div className={css.Items}>
							<p className={css.Key}>Also Designated as: </p>
							<p>-</p>
						</div>
						<div className={css.Items}>
							<p className={css.Key}>Address: </p>
							<p>International House, 36-38 Cornhill</p>
						</div>
					</div>
				</div>
			</div>

			<div>
				<p className={css.SubTitle}>Terms & Condition</p>
				<div className={css.termsContent}>
					{loading && (
						<div className={css.loadingState}>
							<p>Loading document preview...</p>
						</div>
					)}
					{error && (
						<div className={css.errorState}>
							<p>{error}</p>
						</div>
					)}
					{!loading &&
						!error &&
						(documentUrl ? (
							<div className={css.pdfViewerContainer}>
								<Document
									file={documentUrl}
									onLoadSuccess={onDocumentLoadSuccess}
									loading={
										<div className={css.viewerLoading}>Loading document...</div>
									}
									error={
										<div className={css.viewerError}>Failed to load PDF.</div>
									}
								>
									{pages.map((page) => (
										<div key={`page_${page}`} className={css.pdfPage}>
											<Page pageNumber={page} />
										</div>
									))}
								</Document>
							</div>
						) : (
							<ol>
								{clauses.map((clause) => (
									<li key={clause.id} className={css.ListTitles}>
										<div>{clause.name}</div>
										<p
											className={css.Details}
											dangerouslySetInnerHTML={{ __html: clause.details }}
										></p>
									</li>
								))}
							</ol>
						))}
				</div>
			</div>
			<div>
				<p className={css.SubTitle}>Signature</p>
				<div className={css.SignRow}>
					<div>
						<p className={css.SignatureNames}>Chinedu Abanobi</p>
						<p>Managing Director at Fieldbase</p>
					</div>
					<div>
						<p className={css.SignatureNames}>Contact Name</p>
						<p>Contact Designation</p>
					</div>
				</div>
			</div>
		</div>
	);
});

export default TemplateReview;
